<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="400px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <el-form-item prop="name" label="策略名称">
                        <el-col :span="18">
                            <el-input v-model="form.name" maxlength="80"></el-input>
                        </el-col>
                    </el-form-item>

                    <el-form-item prop="teacherUser" label="选择人员绑定">
                        <el-button @click="findUser()">{{form.teacherUserLabel}}</el-button>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';

    export default {
        data(){
            return{
                visible: false,
                isAuto:false,
                transferVisible:false,
                props: { checkStrictly: true},
                form:{
                    id:"",
                    deptId:"",
                    name:"",
                    deviceNo:"",
                    teacherUser:[],
                    teacherUserLabel:"请选择"
                },
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ]
                },
                devices:[]
            }
        },
        created:function () {
        },
        components: {
            userTransfer
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // 初始值
                this.form.id=data.id;
                this.form.name=data.name;
                this.form.deviceNo=data.deviceNo;
                this.form.deptId=data.deptId;
                //绑定人员
                this.getTeacherUser(data.id);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 绑定人员
            getTeacherUser(teacherId){
                let url  = this.listSetTeacherUserUrl;
                let data = {setTeacherId:teacherId};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      let gateUserArr=new Array();
                      let data=res.data.list;
                      for(var i=0;i<data.length;i++){
                          gateUserArr.push(data[i].userId);
                      }
                      this.form.teacherUser = gateUserArr; 
                      this.form.teacherUserLabel=res.data.list.length+"人";
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 绑定人员
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.$util.isNotEmpty(this.form.teacherUser)){
                        this.$refs['userTransfer'].init(2,this.form.teacherUser,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                    }
                })
            },
            setUser(keyArr){
                if(keyArr.length == 0){
                    this.form.teacherUser=keyArr;
                    this.form.teacherUserLabel="请选择";
                }else{
                    this.form.teacherUser=keyArr;
                    this.form.teacherUserLabel=keyArr.length+"人";
                }
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){

                        let url = this.setTeacherTimeUpdateUrl;
                        let data = {
                            id:this.form.id,
                            deptId:this.form.deptId,
                            name:this.form.name,
                            deviceNo:this.form.deviceNo,
                            teacherUser:this.form.teacherUser.join()
                        };

                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/set/tearcher/Update.vue